import { addOrUpdateNodeConfig, findNodeConfigById } from "@/services/serviceConfig";
import { Spin, message } from "antd";
import { useEffect, useRef, useState } from "react";
import { SDrawer, SGeneralForms } from "shj-components";
import { getEnums } from "@/services/homeService";
const addAndEdit = (props: any) => {
    const formRef = useRef<any>()
    const { visibleDrawer = false, title = '新增', record, closeDetails, reloadList } = props
    const id = record?.id
    const [loading, setLoading] = useState(false);
    const [spinLoading, setSpinLoading] = useState(false);
    const onSubmit = (values) => {
        setLoading(true)
        addOrUpdateNodeConfig(values).then((res) => {
            setLoading(false)
            message.success(res.message || "操作成功")
            reloadList()
            closeDetails()
        }).catch(() => {
            setLoading(false)
        })
    }
    useEffect(() => {
        if (visibleDrawer) {
            formRef.current?.onFormRef()?.resetFields();
            formRef?.current?.updateOptions();
            initFn()
        }
    }, [visibleDrawer])
    const initFn = () => {
        if (id) {
            setSpinLoading(true)
            findNodeConfigById(id).then(res => {
                formRef.current?.onFormRef()?.setFieldsValue({...res})
                setSpinLoading(false)
            })
        }
    }
    const getOptions = (): Promise<{ [key: string]: any; }> => {
        const statusList = [{label: '启用', value: true},{label: '禁用', value: false}]
        return new Promise(async (resolve) => {
            try {
                const nodeTypeEnum = await getEnums("plus-pm", "com.shj.saas.plus.pm.domain.node.enums.NodeTypeEnum")
                resolve({
                    nodeTypeEnum,
                    statusList
                });
            } catch (e) { }
        });
    };
    return <>
        <SDrawer
            width={800}
            title={id ? '编辑' : title}
            open={visibleDrawer}
            onClose={closeDetails}
            onSubmit={onSubmit}
            loading={loading}
            destroyOnClose
        >
            <Spin spinning={spinLoading}>
                <SGeneralForms
                    ref={formRef}
                    layout="vertical"
                    httpOptionsFn={getOptions}
                    initialValues={{enabled: true}}
                    configs={[
                        {
                            title: '',
                            formItem: [
                                {label: 'id', name: 'id', hidden: true},
                                {
                                    name: 'name',
                                    label: '节点名称',
                                    required: true,
                                    spanCol: 12,
                                    comConfig: {
                                        maxLength: 50,
                                    },
                                },
                                {
                                    label: '节点类型',
                                    name: 'type',
                                    spanCol: 12,
                                    required: true,
                                    type: "select",
                                    data: 'nodeTypeEnum',
                                    comConfig: {
                                        fieldNames: {
                                            label: 'description',
                                            value: 'key'
                                        }
                                    }
                                },
                                {
                                    label: '状态',
                                    name: 'enabled',
                                    type: 'switch',
                                    required: true,
                                    spanCol: 12,
                                },
                                {
                                    name: 'remarks',
                                    label: '节点说明',
                                    required: true,
                                    type: "textarea",
                                    spanCol: 24,
                                    comConfig: {
                                        maxLength: 200,
                                    },
                                },
                            ]
                        }
                    ]} />
            </Spin>
        </SDrawer>
    </>
};
export default addAndEdit